import { useMemo } from "react";
import StatusStepper from "components/StatusStepper/StatusStepper";
import {
  TrackingOrderDetailsContainer,
  StatusChip,
  EstimatedTimeCard,
  OrderDetailsSection,
  EstimatedTimeHeader,
  EstimatedTimeIcon,
  EstimatedTimeLabel,
  EstimatedTimeValue,
  StatusSectionHeader,
  StatusTitle
} from "layout/styles";
import { StatusName } from "config/config";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { getEstimatedDeliveryTime } from "utils/getEstimatedDeliveryTime";


const getStatusColor = (status) => {
  switch (status) {
    case StatusName.completed:
      return 'success';
    case StatusName.canceled:
    case StatusName.canceled_from_provider:
    case StatusName.rejected:
      return 'error';
    case StatusName.ready:
    case StatusName.picked_up:
      return 'warning';
    default:
      return 'primary';
  }
};

const OrderDetails = ({
  orderInfo,
  activeOrderStep,
  trackUrl,
  activeOrderStatus,
}) => {
  const isShowEstimatedTime = useMemo(() => {
    return activeOrderStatus !== StatusName.canceled &&
      // activeOrderStatus !== StatusName.canceled_from_provider &&
      activeOrderStatus !== StatusName.rejected &&
      orderInfo?.estimatedTime && !trackUrl;
  }, [activeOrderStatus, orderInfo, trackUrl]);

  const isShowStatusSection = useMemo(() => {
    return activeOrderStatus !== StatusName.canceled &&
      // activeOrderStatus !== StatusName.canceled_from_provider &&
      activeOrderStatus !== StatusName.closed &&
      activeOrderStatus !== StatusName.rejected;
  }, [activeOrderStatus]);

  return (
    <TrackingOrderDetailsContainer>
      {/* Estimated Delivery Time Card */}
      {isShowEstimatedTime && (
        <EstimatedTimeCard>
          <EstimatedTimeHeader>
            <EstimatedTimeIcon as={AccessTimeIcon} />
            <EstimatedTimeLabel variant="body2">
              Estimated Delivery Time
            </EstimatedTimeLabel>
          </EstimatedTimeHeader>
          <EstimatedTimeValue variant="h4">
            {getEstimatedDeliveryTime(
              orderInfo.estimatedTime,
              orderInfo?.isScheduled, 
              orderInfo?.timeZoneId
            )}
          </EstimatedTimeValue>
        </EstimatedTimeCard>
      )}

      {/* Status Section */}
      <OrderDetailsSection>
        <StatusSectionHeader>
          <StatusTitle variant="h5">
            Order Status
          </StatusTitle>
          <StatusChip 
            label={activeOrderStatus} 
            color={getStatusColor(activeOrderStatus)}
            variant="filled"
            size="small"
          />
        </StatusSectionHeader>
      </OrderDetailsSection>

      {/* Progress Stepper */}
      {isShowStatusSection && (
        <OrderDetailsSection>
          <StatusStepper activeStep={activeOrderStep} />
        </OrderDetailsSection>
      )}
    </TrackingOrderDetailsContainer>
  );
};

export default OrderDetails;